import TicketSectionSkeleton from 'app/components/TicketSection/TicketSectionSkeleton';
import React from 'react';
import CalendarWeekDaySkeleton from './CalendarWeekDaySkeleton';

const CalendarContainerSkeleton = () => {
  return (
    <div>
      <div className="p-[12px] sm:p-[24px] grid sm:grid-cols-2 gap-[12px]">
        {[1, 2, 3, 4].map(id => (
          <CalendarWeekDaySkeleton key={id} />
        ))}
      </div>
      <div className="border-t border-neutral-40">
        <TicketSectionSkeleton />
      </div>
    </div>
  );
};

export default CalendarContainerSkeleton;
